import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'; 
import Swal from 'sweetalert2';
import Select from 'react-select';
import loadingGif from '../../assets/loading.gif';
import {
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  FormControlLabel,
  Box,
  LinearProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogAction,
  Tooltip,
} from '@mui/material';
import KeyboardReturnRoundedIcon from '@mui/icons-material/KeyboardReturnRounded';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import API_BASE_URL from '../../config';
import './EditJobFlowSettings.css';

ChartJS.register(BarElement, CategoryScale, LinearScale, ChartDataLabels);

const EditJobFlowSettings = () => {
    const { orgId, jobFlowId } = useParams();
    const [organization, setOrganization] = useState(null);
    const [jobFlowName, setJobFlowName] = useState('New Job Flow');
    const [loading, setLoading] = useState(true);
    const [tableData, setTableData] = useState([
        { id: 1, stepName: 'Step 1', stepColor: '#d9d9d9', allowedRoles: [], emailNotification: false, allowUpdate: true },
        { id: 2, stepName: 'Step 2', stepColor: '#d1c842', allowedRoles: [], emailNotification: false, allowUpdate: true },
        { id: 3, stepName: 'Step 3', stepColor: '#683b08', allowedRoles: [], emailNotification: false, allowUpdate: true },
        { id: 4, stepName: 'Completed', stepColor: '#2b2b2b', allowedRoles: [], emailNotification: false, allowUpdate: false },
    ]);
    const [orgRole, setOrgRole] = useState([]);
    const navigate = useNavigate();
    const [warningMessage, setWarningMessage] = useState('');
    const [maxFormDefinatioNItems, setMaxFormDefinationItems] = useState(0);
    const [currentEditId, setCurrentEditId] = useState(null);
    const [formFields, setFormFields] = useState([]); // fields for the dialog
    const [newQuestionName, setNewQuestionName] = useState('');
    const [newQuestionType, setNewQuestionType] = useState('boolean');
    const [newDropdownOptions, setNewDropdownOptions] = useState('');
    const [editFormOpen, setEditFormOpen] = useState(false);

    const [overrideEnabled, setOverrideEnabled] = useState(0);
    const [overrideSeconds, setOverrideSeconds] = useState(0);

    const getContrastColor = (hexColor) => {
        // Remove '#' if present
        const color = hexColor.charAt(0) === '#' ? hexColor.substring(1) : hexColor;
        // Convert to RGB
        const r = parseInt(color.substr(0, 2), 16);
        const g = parseInt(color.substr(2, 2), 16);
        const b = parseInt(color.substr(4, 2), 16);
        // Calculate luminance
        const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
        // Return black for light colors, white for dark colors
        return luminance > 0.5 ? 'black' : 'white';
    };

    
    const colorStyles = {
        option: (styles, { data, isFocused, isSelected }) => {
            const backgroundColor = isSelected ? data.value : isFocused ? data.value : 'white';
            const color = isSelected || isFocused ? getContrastColor(data.value) : 'black';
            return {
                ...styles,
                backgroundColor,
                color,
                display: 'flex',
                alignItems: 'center',
                cursor: 'pointer',
            };
        },
        singleValue: (styles, { data }) => ({
            ...styles,
            backgroundColor: data.value,
            color: getContrastColor(data.value),
            padding: '2px 8px',
            borderRadius: 4,
            display: 'inline-block',
        }),
    };

    const ColourOption = (props) => {
        const { data, innerRef, innerProps, isFocused, isSelected } = props;
        const backgroundColor = isSelected ? data.value : isFocused ? data.value : 'white';
        const color = isSelected || isFocused ? getContrastColor(data.value) : 'black';

        return (
            <div
                ref={innerRef}
                {...innerProps}
                style={{
                    backgroundColor,
                    color,
                    padding: 8,
                    display: 'flex',
                    alignItems: 'center',
                    cursor: 'pointer',
                }}
            >
                <div
                    style={{
                        width: 16,
                        height: 16,
                        backgroundColor: data.value,
                        marginRight: 8,
                        border: '1px solid #ccc',
                        borderRadius: 2,
                    }}
                />
                {data.label}
            </div>
        );
    };

    const colorOptions = [
        { value: '#d9d9d9', label: 'Light Gray' },
        { value: '#d1c842', label: 'Yellow' },
        { value: '#683b08', label: 'Brown' },
        { value: '#2b2b2b', label: 'Black' },
        { value: '#3e5570', label: 'Blue' },
        { value: '#e63946', label: 'Red' },
        { value: '#f4a261', label: 'Orange' },
        { value: '#2a9d8f', label: 'Teal' },
        { value: '#264653', label: 'Dark Blue' },
        { value: '#6a994e', label: 'Green' },
        { value: '#9a8c98', label: 'Purple' },
        { value: '#ffb703', label: 'Gold' },
        { value: '#8d99ae', label: 'Slate Gray' },
        { value: '#007f5f', label: 'Deep Green' },
        { value: '#d62828', label: 'Crimson' },
        { value: '#f77f00', label: 'Pumpkin' },
        { value: '#003049', label: 'Prussian Blue' },
        { value: '#6a0572', label: 'Dark Violet' },
    ];

    const handleEmailNotificationChange = (id, checked) => {
        setTableData(tableData.map(row => {
            if (row.id === id) {
                return { ...row, emailNotification: checked };
            }
            return row;
        }));
    };
    
    const handleCreateForm = (id, checked) => {
        if (!checked) {
            setTableData(tableData.map(row => 
                row.id === id ? { ...row, allowUpdate: false, formDefinition: undefined } : row
            ));
            return;
        }

        const step = tableData.find(row => row.id === id);
        if (!step) {
            console.error('Step not found');
            return;
        }
        setCurrentEditId(id);
        setFormFields(step.formDefinition ? step.formDefinition.fields : []);
        setNewQuestionName('');
        setNewQuestionType('boolean');
        setNewDropdownOptions('');
        setEditFormOpen(true);
    };




    useEffect(() => {
        const fetchOrganizationDetails = async () => {
            const token = localStorage.getItem('token');
    
            if (!token) {
                navigate('/unauthorized');
                return;
            }
    
            try {
                const orgResponse = await axios.get(`${API_BASE_URL}/org/organization-settings/organization-name`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { orgId },
                });
    
                if (orgResponse.status === 403) {
                    navigate('/unauthorized');
                    return;
                }
                setOrganization(orgResponse.data);
                console.log(orgResponse.data);
    
                const org_roles = await axios.get(`${API_BASE_URL}/org/organization-settings/roles/${orgId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
    
                if (org_roles.status === 403) {
                    navigate('/unauthorized');
                    return;
                }
                const roleOptions = org_roles.data.map(role => ({
                    value: role.role_id,
                    label: role.role_name,
                }));
    
                setOrgRole(roleOptions);
    
                // Get details about existing job flow
                const currentJobFlow = await axios.get(`${API_BASE_URL}/org/organization-settings/job-flow/${jobFlowId}`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { jobFlowId, orgId },
                });
    
                setJobFlowName(currentJobFlow.data.flow_name);
                setOverrideEnabled(currentJobFlow.data.override_settings.override || 0);
                setOverrideSeconds(currentJobFlow.data.override_settings.seconds || 0);

                const formDefinationItemResponse = await axios.get(`${API_BASE_URL}/org/organization-settings/max-form-defination-item`, {
                    headers: { Authorization: `Bearer ${token}` },
                    params: { orgId },
                });

                if (formDefinationItemResponse.status === 403) {
                    navigate('/unauthorized');
                    return;
                }
                setMaxFormDefinationItems(formDefinationItemResponse.data);
    
                const updatedTableData = currentJobFlow.data.steps.map(step => {
                    let allowedRolesArray = [];
                
                    if (Array.isArray(step.allowed_roles)) {
                        allowedRolesArray = step.allowed_roles;
                    } else {
                        console.warn('Unexpected format for allowed_roles:', step.allowed_roles);
                    }
                
                    return {
                        id: step.id,
                        stepName: step.step_name,
                        stepColor: step.step_color,
                        allowedRoles: allowedRolesArray.map(role => ({
                            value: role.id,
                            label: role.name,
                        })),
                        emailNotification: Boolean(step.email_notification),
                        allowUpdate: Boolean(step.allow_update),
                        formDefinition: step.form_definition,
                    };
                });
                
                setTableData(updatedTableData);
    
            } catch (error) {
                console.error('Error fetching data:', error);
                navigate('/unauthorized');
                return;
            } finally {
                setLoading(false);
            }
        };
    
        fetchOrganizationDetails();
    }, [orgId, navigate, jobFlowId]);

    const handleStepNameChange = (id, field, value) => {
        if (field === 'stepName' && value.length > 30) {
            setWarningMessage('Step Name must not exceed 30 characters.');
            return;
        }
    
        // Update only if the step is not "Completed"
        if (field === 'stepName' && id !== tableData[tableData.length - 1].id) {
            setTableData(tableData.map(row => {
                if (row.id === id) {
                    const updatedRow = { ...row, [field]: value };
                    return updatedRow;
                }
                return row;
            }));
            setWarningMessage('');
        }
    };

        const handleEditForm = (id) => {
        const step = tableData.find(row => row.id === id);
        if (!step) {
            console.error('Step not found');
            return;
        }
        setCurrentEditId(id);
        setFormFields(step.formDefinition ? step.formDefinition.fields : []);
        setNewQuestionName('');
        setNewQuestionType('boolean');
        setNewDropdownOptions('');
        setEditFormOpen(true);
    };

    const handleAddQuestion = () => {
            if (!newQuestionName.trim()) {
                alert('Please enter a question name');
                return;
            }
            if (newQuestionType === 'dropdown' && !newDropdownOptions.trim()) {
                alert('Please enter options for the dropdown');
                return;
            }
            if (formFields.length >= maxFormDefinatioNItems) {
                alert(`Cannot add more than ${maxFormDefinatioNItems} questions.`);
                return;
            }
            const newField = {
                name: newQuestionName.toLowerCase().replace(/\s+/g, '_'),
                label: newQuestionName,
                type: newQuestionType,
                options: newQuestionType === 'dropdown' ? newDropdownOptions.split(',').map(opt => opt.trim()) : undefined,
            };
            setFormFields([...formFields, newField]);
            setNewQuestionName('');
            setNewDropdownOptions('');
            setNewQuestionType('boolean');
        };
    
        const handleDeleteQuestion = (index) => {
            setFormFields(formFields.filter((_, i) => i !== index));
        };
    
        const handleSaveForm = () => {
            setTableData(tableData.map(row => 
                row.id === currentEditId ? { ...row, allowUpdate: true, formDefinition: { fields: formFields } } : row
            ));
            setEditFormOpen(false);
            Swal.fire({
                title: 'Form Saved',
                text: 'The form has been updated successfully.',
                icon: 'success',
                confirmButtonText: 'Close',
                allowOutsideClick: false,
                allowEscapeKey: false
            });
        };
    
        const handleCancelEdit = () => {
            setEditFormOpen(false);
        };



    const handleCreateJobFlow = async (event) => {
        event.preventDefault();
    
        const isValid = tableData.slice(0, -1).every(row =>
            row.stepName.trim() !== '' && 
            row.stepColor.trim() !== '' && 
            row.allowedRoles.length > 0
        );
    
        if (!isValid) {
            Swal.fire('Validation Error', 'Please fill out all fields before submitting.', 'error');
            return;
        }
    
        // Prepare the job flow data
        const newJobFlow = { 
            orgId,
            jobFlowName,
            jobFlowId,
            steps: tableData.map((row, index) => ({
                index: index + 1,
                stepName: row.stepName,
                stepColor: row.stepColor,
                allowedRoles: row.allowedRoles.map(role => role.value),
                emailNotification: row.emailNotification,
                allowUpdate: row.allowUpdate,
                ...(row.allowUpdate && row.formDefinition && { formDefinition: row.formDefinition })
            })),
            overrideEnabled,
            overrideSeconds,
        };
    
        // Display confirmation dialog
        Swal.fire({
            title: 'Confirm Edit',
            text: 'Are you sure you want to edit this job flow?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, edit it!',
            cancelButtonText: 'No, cancel!',
        }).then(async (result) => {
            if (result.isConfirmed) {
                const token = localStorage.getItem('token');
                try {
                    const response = await axios.post(`${API_BASE_URL}/org/organization-settings/job-flow/update`, newJobFlow, {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                    });
    
                    if (response.status === 201) {
                        const result = await Swal.fire('Success', 'Job flow edited successfully!', 'success');
                        // Redirect if the user clicks "OK"
                        if (result.isConfirmed) {
                            navigate('/organization/settings');
                        }
                    } else {
                        Swal.fire('Error', response.data.message || 'Failed to edit job flow.', 'error');
                    }
                } catch (error) {
                    console.error('Error editing job flow:', error);
                    Swal.fire('Error', error.response?.data?.message || 'Failed to edit job flow.', 'error');
                }
            }
        });
    };
    
    
     
    
    

    const handleAddRow = () => {
        if (tableData.length >= 20) {
            setWarningMessage('Limit reached. Cannot create over 20 steps!');
            return;
        }
    
        // Create a new step
        const newStepId = Math.max(...tableData.map(row => row.id), 0) + 1;
        const newRow = {
            id: newStepId, // New ID for the new step
            stepName: `Step ${newStepId - 1}`,
            stepColor: '#8d99ae',
            allowedRoles: [],
            emailNotification: false,
            allowUpdate: false
        };
    
        // Update the table data
        setTableData(prevData => {
            const newData = [...prevData]; // Create a copy of the existing data
    
            // Insert the new row before the "Completed" step (which is always the last item)
            const completedIndex = newData.length - 1; // Get the index of "Completed" step
            newData.splice(completedIndex, 0, newRow); // Insert the new row
    
            // Increment the "Completed" step's index
            newData[completedIndex + 1] = { 
                ...newData[completedIndex + 1], 
                id: newData[completedIndex + 1].id + 1 // Increment the ID of the "Completed" step
            };
    
            // Remap IDs to be sequential again
            return newData.map((row, index) => ({
                ...row,
                id: index + 1 // Reassign IDs starting from 1
            }));
        });
    
        setWarningMessage(''); // Reset warning message on add row
    };
    
    const handleChange = (id, field, value) => {
        if (field === 'stepName' && value.length > 30) {
            setWarningMessage('Step Name must not exceed 30 characters.');
            return;
        }

        // Update only if the step is not "Completed"
        if (field !== 'stepName' || (field === 'stepName' && id !== tableData[tableData.length - 1].id)) {
            setTableData(tableData.map(row => (row.id === id ? { ...row, [field]: value } : row))); // Update row
            setWarningMessage(''); // Clear warning message when input changes
        }
    };

    const handleDeleteRow = (id) => {
        if (id === tableData[tableData.length - 1].id) {
            Swal.fire('Cannot delete', 'The "Completed" step cannot be deleted.', 'error');
            return;
        }
    
        Swal.fire({
            title: 'Are you sure?',
            text: "This action cannot be undone!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Yes, delete it!',
        }).then((result) => {
            if (result.isConfirmed) {
                setTableData(tableData.filter((row) => row.id !== id));
                Swal.fire('Deleted!', 'The step has been deleted.', 'success');
            }
        });
    };

    const handleRoleChange = (id, selectedOptions) => {
        const updatedRoles = selectedOptions.map(option => ({
            value: option.value,
            label: option.label,
        }));
        setTableData(tableData.map(row => (row.id === id ? { ...row, allowedRoles: updatedRoles } : row)));
    };


    const handleColorChange = (id, color) => {
        setTableData(tableData.map(row => (row.id === id ? { ...row, stepColor: color } : row)));
    };
    
    const handleBarClick = (elements) => {
        if (elements.length > 0) {
            const index = elements[0].index + 1;
            const step = tableData[index];
            console.log('Step', index, 'clicked');
            // console.log(step);
        }
    };

    const getRandomInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

    const chartData = {
        labels: tableData.map(row => row.stepName),
        datasets: [
            {
                label: 'Job Flow Steps',
                data: tableData.map(() => getRandomInt(10, 100)),
                backgroundColor: tableData.map(row => row.stepColor || '#3e5570'),
                borderColor: tableData.map(row => row.stepColor ? 'rgba(0, 0, 0, 0.5)' : '#000'),
                borderWidth: 0,
            },
        ],
    };

    
    const chartOptions = {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
            y: {
                beginAtZero: true,
                grid: {
                    display: true,
                },
                border: {
                    display: false,
                },
            },
            x: {
                grid: {
                    display: false,
                },
                ticks: {
                    maxRotation: 45,
                    minRotation: 0,
                    autoSkip: false,
                },
            },
        },
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                enabled: true,
                mode: 'index',
                intersect: false, 
                callbacks: {
                    label: (tooltipItem) => {
                        const stepName = tooltipItem.label;
                        const value = tooltipItem.parsed.y;
                        return `${stepName}: ${value}`;
                    },
                },
            },
            datalabels: {
                display: true,
                anchor: 'center', 
                align: 'center',  
                formatter: (value) => value, 
                color: '#fff',
                font: {
                    weight: 'bold',
                    size: 12,
                },
            },
        },
        bar: {
            maxBarThickness: 100,
        },
        interaction: {
            mode: 'nearest',
            intersect: true,
        },
        onClick: (event, elements) => handleBarClick(elements),
    };

    if (loading) {
        return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: 'calc(100vh - 64px)',
            backgroundColor: '#fff',
        }}>
            <img src={loadingGif} alt="Loading..." style={{ width: '30%', height: '30%', objectFit: 'contain' }} />
        </div>
        );
    }
    
    return (
        <>
            <Card>
                
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1, mt: 0 }}>
                    <IconButton
                        onClick={() => navigate('/organization/settings')}
                        aria-label="Back"
                        sx={{
                            border: '1px solid black',
                            backgroundColor: 'transparent',
                            color: 'black',
                            margin: 2,
                            height: 36,
                            width: 36,
                            borderRadius: 1,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                    <KeyboardReturnRoundedIcon />
                    </IconButton>
                </Box>
                <CardContent>
                    <Grid container spacing={3} mb={2}>
                        <Grid item xs={12} md={12}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h5" gutterBottom>{organization.orgName}: Edit Job Flow</Typography>
                                        <TextField
                                            fullWidth
                                            multiline
                                            rows={1}
                                            size='small'
                                            label="Job Flow Name*"
                                            value={jobFlowName}
                                            onChange={(e) => setJobFlowName(e.target.value)}
                                            sx={{ mb: 2 }}
                                        />
                                        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                            <FormControlLabel
                                                control={
                                                    <Switch
                                                        checked={overrideEnabled === 1}
                                                        onChange={(e) => setOverrideEnabled(e.target.checked ? 1 : 0)}
                                                    />
                                                }
                                                label="Enable Order Editing Override"
                                            />
                                            <Tooltip 
                                                title="Only 1 user is allowed to edit an order at a time so the jobs won't be overwritten if more than 1 user tries to edit or update the order at the same time. Enable this override to allow the new user to gain editing permission if the user with edit permission doesn't respond to the access request from other users within the specified timeout."
                                                placement="right"
                                            >
                                                <IconButton size="small" sx={{ mr: 1 }}>
                                                    <Typography variant="body2" color="text.secondary">?</Typography>
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                        
                                        <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                            <TextField
                                                fullWidth
                                                type="number"
                                                size="small"
                                                label="Order Editing Request Timeout (seconds)"
                                                value={overrideSeconds}
                                                onChange={(e) => setOverrideSeconds(Math.max(0, Math.min(3600, parseInt(e.target.value) || 0)))}
                                            />
                                            <Tooltip 
                                                title="This determines how long the access request will last on the screen of the user who has edit permission. If the user doesn't respond within this many seconds, it will automatically give the requesting user the editing permission of the order. 0 means permanently show the request. Maximum is 1 hour (3600 seconds)."
                                                placement="right"
                                            >
                                                <IconButton size="small" sx={{ mr: 1 }}>
                                                    <Typography variant="body2" color="text.secondary">?</Typography>
                                                </IconButton>
                                            </Tooltip>
                                        </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <Card>
                                <CardContent>
                                    <Typography variant="h6" gutterBottom>
                                        Job Flow Statistics
                                    </Typography>
                                    <Box sx={{ height: '30vh', position: 'relative' }}>
                                        <Bar data={chartData} options={{
                                            ...chartOptions,
                                            maintainAspectRatio: false,
                                            responsive: true
                                        }} />
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>
                    <form onSubmit={handleCreateJobFlow}>
                        <Grid container spacing={3}>
                            <Grid item xs={12}>
                            <TableContainer component={Paper}>
                                <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>#</TableCell>
                                        <TableCell>Step Name</TableCell>
                                        <TableCell>Color</TableCell>
                                        <TableCell>Access</TableCell>
                                        <TableCell>Email</TableCell>
                                        <TableCell>Form</TableCell>
                                        <TableCell>Actions</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData.map((row, index) => (
                                    <TableRow key={row.id}>
                                        <TableCell>{index + 1}</TableCell>
                                        <TableCell>
                                            <TextField
                                                value={row.stepName}
                                                onChange={(e) => handleStepNameChange(row.id, 'stepName', e.target.value)}
                                                disabled={row.stepName === 'Completed'}
                                            />
                                        </TableCell>
                                        <TableCell>
                                            <Select
                                                options={colorOptions}
                                                value={colorOptions.find(option => option.value === row.stepColor)}
                                                onChange={(selectedOption) => handleColorChange(row.id, selectedOption.value)}
                                                isSearchable={false}
                                                styles={colorStyles}
                                                components={{ Option: ColourOption }}
                                            />
                                        </TableCell>
                                        <TableCell sx={{ maxWidth: 500 }}>
                                            <Select
                                                isMulti
                                                options={orgRole}
                                                value={row.allowedRoles}
                                                onChange={selectedOptions => handleRoleChange(row.id, selectedOptions)}
                                                closeMenuOnSelect={false}
                                            />
                                        </TableCell>
                                        <TableCell>
                                        <FormControlLabel
                                            control={
                                            <Switch
                                                checked={row.emailNotification}
                                                onChange={(e) => handleEmailNotificationChange(row.id, e.target.checked)}
                                            />
                                            }
                                        />
                                        </TableCell>
                                        <TableCell>
                                        <FormControlLabel
                                            control={
                                            <Switch
                                                checked={row.allowUpdate}
                                                onChange={(e) => handleCreateForm(row.id, e.target.checked)}
                                            />
                                            }
                                        />
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                variant="outlined"
                                                size="small"
                                                disabled={!row.allowUpdate}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleEditForm(row.id);
                                                }}
                                                sx={{ mr: 1 }}
                                            >
                                                Edit Form
                                            </Button>
                                            <Button
                                                variant="outlined"
                                                color="error"
                                                size="small"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    handleDeleteRow(row.id);
                                                }}
                                                disabled={row.id === tableData[tableData.length - 1].id}
                                                sx={{ display: row.id === tableData[tableData.length - 1].id ? 'none' : 'inline-flex' }}
                                            >
                                                Delete
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell colSpan={7}>
                                            <Button variant="contained" color="primary" onClick={handleAddRow}>
                                                Add Step
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                                </Table>
                            </TableContainer>
                            </Grid>
                            <Grid item xs={12}>
                            <Typography color="error">{warningMessage}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                            <Button type="submit" variant="contained" color="primary">
                                Update Job Flow
                            </Button>
                            </Grid>
                        </Grid>
                    </form>
                </CardContent>
            </Card>

            <Dialog open={editFormOpen} onClose={handleCancelEdit} maxWidth="md" fullWidth>
                <DialogTitle sx={{ color: 'black' }}>
                    Edit Form
                    <IconButton
                        aria-label="close"
                        onClick={handleCancelEdit}
                        sx={{ position: 'absolute', right: 8, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent dividers>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                        <thead>
                            <tr>
                                <th style={{ border: '1px solid #ddd', padding: 12, width: '20%' }}>Name</th>
                                <th style={{ border: '1px solid #ddd', padding: 12, width: '20%' }}>Type</th>
                                <th style={{ border: '1px solid #ddd', padding: 12, width: '40%' }}>Dropdown Options</th>
                                <th style={{ border: '1px solid #ddd', padding: 12, width: '20%' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {formFields.map((field, index) => (
                                <tr key={index}>
                                    <td style={{ border: '1px solid #ddd', padding: 12 }}>{field.label}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 12 }}>{field.type}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 12 }}>{field.options ? field.options.join(', ') : ''}</td>
                                    <td style={{ border: '1px solid #ddd', padding: 12 }}>
                                        <Button variant="contained" color="error" size="small" onClick={() => handleDeleteQuestion(index)}>
                                            Delete
                                        </Button>
                                    </td>
                                </tr>
                            ))}
                            <tr>
                                <td style={{ border: '1px solid #ddd', padding: 12 }}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        placeholder="Question Name"
                                        value={newQuestionName}
                                        onChange={(e) => setNewQuestionName(e.target.value)}
                                    />
                                </td>
                                <td style={{ border: '1px solid #ddd', padding: 12 }}>
                                    <select
                                        value={newQuestionType}
                                        onChange={(e) => setNewQuestionType(e.target.value)}
                                        style={{ width: '100%', padding: 8 }}
                                    >
                                        <option value="boolean">boolean</option>
                                        <option value="dropdown">dropdown</option>
                                        <option value="text">text</option>
                                        <option value="datetime">datetime</option>
                                    </select>
                                </td>
                                <td style={{ border: '1px solid #ddd', padding: 12 }}>
                                    <TextField
                                        fullWidth
                                        size="small"
                                        placeholder="Comma-separated options"
                                        value={newDropdownOptions}
                                        onChange={(e) => setNewDropdownOptions(e.target.value)}
                                        disabled={newQuestionType !== 'dropdown'}
                                    />
                                </td>
                                <td style={{ border: '1px solid #ddd', padding: 12 }}>
                                    <Button variant="contained" onClick={handleAddQuestion}>
                                        Add Question
                                    </Button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCancelEdit}>Cancel</Button>
                    <Button variant="contained" onClick={handleSaveForm} disabled={formFields.length === 0}>
                        Save Form
                    </Button>
                </DialogActions>
            </Dialog>

        
        </>
    );
};

export default EditJobFlowSettings;
